export const LOCAL_STORAGE_ONBOARDING_SHOW_KEY = 'onboarding_show';
export const LOCAL_STORAGE_ONBOARDING_STEP_KEY = 'onboarding_current_step';

export const getOnboardingStepKey = () =>
  localStorage.getItem(LOCAL_STORAGE_ONBOARDING_STEP_KEY);

export const setOnboardingStepKey = (stepKey?: string | null) => {
  if (!stepKey) {
    localStorage.removeItem(LOCAL_STORAGE_ONBOARDING_STEP_KEY);
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_ONBOARDING_STEP_KEY, stepKey);
};

export const clearOnboardingStepKey = () =>
  localStorage.removeItem(LOCAL_STORAGE_ONBOARDING_STEP_KEY);
